import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useParams} from 'react-router-dom';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {scopes, resources} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Container, Card, Grid, Button, Icon, Input, Table, Tab, Dropdown, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import ComboDetailsTab from './comboDetailsTab';
import ComboDealersTab from './comboDealersTab';
import ComboKatashikisTab from './comboKatashikisTab';

import './styles.scss';

const {
  navigateTo,
  fetchComboDetail,
  updateCombo,
  createCombo,
} = Actions;

const installTypeOptions = [
  {'key': 'TDE', 'text': 'TOYOTA', 'value': 'TDE'},
  {'key': 'PRO', 'text': 'PROVEEDOR', 'value': 'PRO'},
];

const ComboEdit = () => {
  const {code} = useParams();
  const permissions = useSelector((state) => state.session.permissions);
  const loading = useSelector((state) => state.comboDetails.loading);
  const comboDetails = useSelector((state) => state.comboDetails.data);
  const [comboDetailsState, setComboDetailsState] = useState({
    'company': 'TE',
    'code': '',
    'description': '',
    'status': 'A',
    'installType': '',
    'fr': null,
    'comboDetails': [],
    'comboDealers': [],
    'comboKatashikies': [],
    'openOrders': [],
  });
  const [tabActive, setTabActive] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.CombosManagement, scopes.See) &&
      !hasAccessPermission(permissions, resources.CombosManagement, scopes.Edit)) {
      dispatch(navigateTo(paths.AccessDenied));
    }
    if (code) {
      dispatch(fetchComboDetail(code));
    }
  }, []);

  useEffect(() => {
    if (code && comboDetails) {
      setComboDetailsState(comboDetails);
    }
  }, [comboDetails]);
  
  const getChangeStatePermissions = () => {
    if (hasAccessPermission(permissions, resources.CombosManagement, scopes.Edit)) {
      return true;
    }
    return false;
  };

  const handleTabChange = (e, tab) => {
    e.preventDefault();
    setTabActive(tab.activeIndex);
  };

  const editComboHeader = (field, value) => {
    setComboDetailsState({...comboDetailsState, [field]: value});
  };

  const handleComboAccessories = (e, acc, action) => {
    e.preventDefault();
    const comboAccessory = {
      'code': acc.code,
      'name': acc.name,
      'franchise': acc.franchise,
      'line': comboDetailsState.comboDetails.length + 1,
      'price': 0,
      'quantity': 0,
    };
    if (action === 'add') {
      setComboDetailsState((currentData) => ({
        ...currentData, 'comboDetails': [...currentData.comboDetails, comboAccessory],
      }));
    } else {
      setComboDetailsState((currentData) => ({
        ...currentData, 'comboDetails': [...currentData.comboDetails.filter((x) => x.code !== comboAccessory.code)],
      }));
    }
  };

  const editComboAccessory = (acc, field, value) => {
    setComboDetailsState((currentData) => ({
      ...currentData, 'comboDetails': [...currentData.comboDetails.map((item) => {
        return item.code === acc.code ? {...item, [field]: value} : item;
      })],
    }));
  };

  const handleComboKatashikies = (e, katashiki, action) => {
    e.preventDefault();
    const comboKatashiki = {
      'carModel': katashiki.carModel,
      'masterCode': katashiki.masterCode,
      'suffix': katashiki.suffix,
    };
    if (action === 'add') {
      setComboDetailsState((currentData) => ({
        ...currentData, 'comboKatashikies': [...currentData.comboKatashikies, comboKatashiki],
      }));
    } else {
      setComboDetailsState((currentData) => ({
        ...currentData, 'comboKatashikies':
          [...currentData.comboKatashikies.filter((x) => x.masterCode !== comboKatashiki.masterCode)],
      }));
    }
  };

  const handleComboDealers = (dealer, addDealer) => {
    if (addDealer) {
      setComboDetailsState((currentData) => ({
        ...currentData, 'comboDealers': [...currentData.comboDealers, dealer],
      }));
    } else {
      setComboDetailsState((currentData) => ({
        ...currentData, 'comboDealers':
          [...currentData.comboDealers.filter((x) => x.identification !== dealer.identification)],
      }));
    }
  };

  const disabled = comboDetailsState ? comboDetailsState.openOrders.length !== 0 : true;

  const isRequired = (field) => {
    return comboDetailsState ? comboDetailsState[field] ? true : false : false;
  };

  const validateComboDetailsZeroValues = () => {
    return comboDetailsState.comboDetails.some((x) => !x.quantity || Number(x.quantity) === 0 ||
      !x.price || Number(x.price) === 0);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {...comboDetailsState, 'comboDetails': comboDetailsState.comboDetails.map((x) => {
      return {...x, 'price': Number(x.price)};
    })};
    code ?
      dispatch(updateCombo({'data': data}, code)) :
      dispatch(createCombo({'data': data}));
  };

  const renderComboDetailTabActive = () => {
    let tabPaneContent = null;
    switch (tabActive) {
      case 1:
        tabPaneContent = <ComboDealersTab comboDealers={comboDetailsState.comboDealers}
          handleComboDealers={handleComboDealers.bind(this)} />;
        break;
      case 2:
        tabPaneContent = <ComboKatashikisTab comboKatashikies={comboDetailsState.comboKatashikies} disabled={disabled}
          handleComboKatashikies={handleComboKatashikies.bind(this)} />;
        break;
      default:
        tabPaneContent = <ComboDetailsTab comboDetailsState={comboDetailsState} disabled={disabled}
          handleComboAccessories={handleComboAccessories.bind(this)}
          editComboAccessory={editComboAccessory.bind(this)} />;
        break;
    }
    return (
      <Tab.Pane>
        {tabPaneContent}
      </Tab.Pane>
    );
  };

  const renderLoader = () => {
    return (
      <Table striped className="toyota-grid">
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="100%">
              <Loader active inline="centered" content="Cargando información" />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };
  
  return (
    <Container fluid className='combos'>
      {loading ? renderLoader() : <>
        <Card raised fluid>
          <div className='title-bar'>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <div className='title'>
                    <h2>Administración de Combos -&nbsp;{code ? code : 'Creación'}</h2>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign='right'>
                  <div>
                    {getChangeStatePermissions() ?
                      <Button primary onClick={(e) => handleSubmit(e)} loading={loading}
                        disabled={!isRequired('code') || !isRequired('description') ||
                        !isRequired('installType') || validateComboDetailsZeroValues()} >
                        {code ? 'Editar' : 'Crear'}
                      </Button> : ''
                    }
                    <Link to={paths.CombosList}>
                      <Icon className='logout' size='big' color='red' />
                    </Link>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Card>
        <Card raised fluid>
          <Grid padded textAlign='left'>
            <Grid.Row>
              <Grid.Column width={10}>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column width={8}>
                      <Input fluid label='Código Combo' value={comboDetailsState.code}
                        disabled={code ? true : false} className={!isRequired('code') ? 'required' : ''}
                        onChange={(e, input) => editComboHeader('code', input.value)} />
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <div className="ui fluid labeled input">
                        <div className="ui label label">Tipo Instalación</div>
                        <Dropdown fluid selection options={installTypeOptions} labeled disabled={disabled}
                          value={comboDetailsState.installType}
                          className={!isRequired('installType') ? 'labeled-dropdown required' : 'labeled-dropdown'}
                          onChange={(e, input) => editComboHeader('installType', input.value)} />
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Input fluid label='Descripción' value={comboDetailsState.description} disabled={disabled}
                        onChange={(e, input) => editComboHeader('description', input.value)}
                        className={!isRequired('description') ? 'required' : ''}/>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column width={6}>
                {comboDetailsState.openOrders.length > 0 ?
                  <Card raised fluid color='grey'>
                    <div className='flex middle'>
                      <Icon name='info circle' color='yellow' size='huge' />
                      <strong>Este combo tiene ordenes de trabajo abiertas por
                        lo que sólo se permite la edición de los concecionarios asociados.</strong>
                    </div>
                    <div style={{'padding': '1em'}}>
                      <Table compact textAlign='center' style={{'fontSize': '12px'}}>
                        <Table.Header>
                          <Table.HeaderCell content='Orden' />
                          <Table.HeaderCell content='Tipo' />
                          <Table.HeaderCell content='Chasis' />
                          <Table.HeaderCell content='Estado' />
                        </Table.Header>
                        <Table.Body>
                          {comboDetailsState.openOrders.map((order, i) => {
                            return <Table.Row key={i}>
                              <Table.Cell content={order.orderId} />
                              <Table.Cell content={order.orderType} />
                              <Table.Cell content={order.chassis} />
                              <Table.Cell content={order.description} />
                            </Table.Row>;
                          })}
                        </Table.Body>
                      </Table>
                    </div>
                  </Card> : ''}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card raised fluid>
          <Grid padded>
            <Grid.Row>
              <Grid.Column>
                <Tab onTabChange={(e, value) => handleTabChange(e, value)} panes={[
                  {'menuItem': 'ACCESORIOS INCLUIDOS', 'render': () => renderComboDetailTabActive()},
                  {'menuItem': 'CONCESIONARIOS ASOCIADOS', 'render': () => renderComboDetailTabActive()},
                  {'menuItem': 'KATASHIKIS ASIGNADOS', 'render': () => renderComboDetailTabActive()},
                ]}></Tab>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
      </>}
    </Container>
  );
};

export default ComboEdit;
